import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../shared/services';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: false
})
export class HelpComponent implements OnInit {

  helpTitle!: string;
  _language: string;

  constructor(public languageService: LanguageService, private router: Router) {
    this._language = this.languageService.language;
  }

  ngOnInit(): void {
    this.helpTitle = (this._language === 'en') ? 'Help' : 'Súgó';
  }
}
